// src/features/permissions/components/PermissionWorkspaceHeader.tsx
import { Card, formatPersianNumber } from '../../../app/components/foundation';
import type { SecurityRole } from '../../security/types/security.types';

export interface PermissionWorkspaceHeaderProps {
  role: SecurityRole;
}

/**
 * Top-of-page header for the permissions workspace. Same glass Card
 * surface as every other card here, but laid out as identity (role
 * name + status badge) plus a small meta list (id, users count, last
 * updated) on one side and a reserved action area on the other. The
 * action button is disabled and non-functional, same placeholder
 * pattern as SecurityWorkspaceHeader / AnalyticsWorkspaceHeader —
 * real workspace actions (edit role, revoke access, etc.) are a later
 * phase.
 */
export function PermissionWorkspaceHeader({ role }: PermissionWorkspaceHeaderProps) {
  return (
    <Card className="vania-permissions-workspace-header">
      <div className="vania-permissions-workspace-header-main">
        <div className="vania-permissions-workspace-header-identity">
          <h1 className="vania-permissions-workspace-name">{role.name}</h1>
          <span className="vania-permissions-status-badge">
            {role.scope === 'system' ? 'SYSTEM' : 'TENANT'}
          </span>
        </div>

        <dl className="vania-permissions-workspace-meta">
          <div>
            <dt>شناسه نقش</dt>
            <dd dir="ltr">{formatPersianNumber(role.role_id ?? role.id)}</dd>
          </div>
          <div>
            <dt>تننت</dt>
            <dd>{role.scope === 'system' ? 'Global' : role.tenant_name || role.tenant_id || '-'}</dd>
          </div>
          <div>
            <dt>Slug</dt>
            <dd dir="ltr">{role.slug}</dd>
          </div>
        </dl>
      </div>

      <div className="vania-permissions-workspace-header-actions">
        <button
          type="button"
          disabled
          className="vania-permissions-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          ویرایش نقش
        </button>
      </div>
    </Card>
  );
}
